import React from 'react';

import { userService } from './LoginService';
import './Login.css';
import { FormGroup, Row, Form, Col, Button, FormControl, FormLabel } from 'react-bootstrap';
import i18n from '../../i18n';


class LoginPage extends React.Component {
    constructor(props) {
        super(props);

        userService.logout();

        this.state = {
            username: '',
            password: '',
            submitted: false,
            loading: false,
            error: '',
            isAutorizate: ((typeof this.props.handleAccept !== 'undefined'))
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        fetch("/Security/GetUserData", {
            method: "POST",
            cache: "no-cache",
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(d => {
                if (d.status === 401)
                    return;

                return d.json()
            })
            .then(d => {

                if (!this.state.isAutorizate)
                    this.state.username = d.LoginName;

            })
            .catch(d => {
                if (window.location.pathname !== "/Login" && window.location.pathname !== "/Security/Logout" && window.location.pathname !== "/Redirect/RedirectToApp")
                    window.location = "/Security/Logout";
            });
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { username, password, isAutorizate } = this.state;

        if (!(username && password)) {
            return;
        }

        this.setState({ loading: true });

        if (isAutorizate) {
            userService.autorization(username, password).then(this.handleSubmitResponse);
        }
        else {
            userService.login(username, password).then(this.handleSubmitResponse);
        }
    }

    handleSubmitResponse = (response) => {
        try {
            if (response.Status === "ERROR")
                throw new Error(response.Message);

            if (this.props.handleAccept) {
                this.props.handleAccept();
            }
            else {
                window.location = "/";
            }
        }
        catch (ex) {
            this.setState({ error: ex.message, loading: false })
        }
    }

    render() {
        const { username, password, submitted, loading, error, isAutorizate } = this.state;
        const subProyect = i18n.t("Login_Sec0_lbl_SubProyect");

        return (

            <div className="boody_login">
                <Row>

                    {!isAutorizate &&

                        <Col>

                            <Row>
                                <Col>

                                    <div className="sidenav">

                                        <div className="login-main-text">
                                            <h1 style={{ textAlign: "center" }}>{i18n.t("Login_Sec0_lbl_Proyect")}</h1>
                                            <br />
                                            {
                                                subProyect != null &&
                                                <div>
                                                    <h2 style={{ textAlign: "center" }}>{subProyect}</h2>
                                                    <br />
                                                </div>
                                            }
                                            <h2 style={{ textAlign: "center" }}>{i18n.t("Login_Sec0_lbl_PageAccess")}</h2>
                                        </div>
                                    </div>

                                </Col>

                            </Row>

                        </Col>

                    }

                    <Col>

                        <Form onSubmit={this.handleSubmit} className={isAutorizate ? "" : "login-form-custom"}>
                            <div class={isAutorizate ? "" : "formdata"}>

                                <div>

                                    <div className={isAutorizate ? "hidden" : ""}>

                                        <img src="/img/logo.png" className="div-logo" />

                                        <br />
                                        <br />

                                    </div>

                                    <Row>
                                        <Col>
                                            <FormGroup className={'' + (submitted && !username ? ' has-error' : '')}>
                                                <FormLabel htmlFor="username">{i18n.t("Login_Sec0_lbl_Username")}</FormLabel>
                                                <FormControl type="text" name="username" value={username} onChange={this.handleChange} autoComplete="off" />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                </div>

                                <Row>
                                    <Col>
                                        <FormGroup className={'' + (submitted && !password ? ' has-error' : '')}>
                                            <FormLabel htmlFor="password" style={{ textAlign: "center" }}>{i18n.t("Login_Sec0_lbl_Password")}</FormLabel>
                                            <FormControl type="password" name="password" value={password} onChange={this.handleChange} autoComplete="off" />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                {error &&
                                    <div className={'alert alert-danger'}>{i18n.t(error)}</div>
                                }

                                <Row>
                                    <Col>
                                        <FormGroup style={{ textAlign: "center" }}>
                                            <Button type="submit" variant="outline-secondary" disabled={loading}>{i18n.t("Login_Sec0_btn_Login")} {loading &&
                                                <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                            }</Button>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </div>
                        </Form>

                    </Col>

                </Row>

            </div>

        );
    }
}

export { LoginPage };


// WEBPACK FOOTER //
// ./src/components/Login/LoginPage.js